export const childhoodIndexContent = (
  <>
    <div className="prose dark:prose-invert max-w-none text-text-muted-light dark:text-text-muted-dark">
      <h2>How we helped</h2>
      <p>
        Township has been part of The Anxious Generation Movement from day one.
        We built the Childhood Index site with their team, working closely with
        their policy team to turn the idea into something real: a live,
        iterative website that could grow as policy changes and states continue
        to act.
      </p>

      <h2>About the Childhood Index</h2>
      <p>
        How well is your state protecting kids online and supporting a healthy
        real-world childhood?
      </p>

      <h2>Background</h2>
      <p>
        Across the country, momentum is building in the movement to reclaim
        childhood and protect kids online. Families everywhere are demanding
        change, and state leaders are stepping up with bold legislation and
        decisive efforts to hold tech companies accountable. But progress varies
        widely state to state, and right now a child&rsquo;s chance to flourish
        depends too much on where they live.
      </p>
      <p>
        Developed by The Anxious Generation Movement, the Childhood Index ranks
        all 50 states on the strength of their laws and leadership across
        phone-free schools, childhood independence, social media age limits, and
        tech regulation. By highlighting effective policies and key
        opportunities, it serves as a benchmark for state leaders and an
        actionable tool to help them accelerate progress.
      </p>
      <p>
        Our four tiers &mdash; National Leaders, Rising Stars, Emerging Action,
        and Limited Action &mdash; reflect where each state stands today, but
        this is not meant to be a final verdict. We believe every state can
        become a National Leader. We&rsquo;ve created this Index to help them
        get there.
      </p>
    </div>
  </>
);
